import { CopyBox } from '../components/CopyBox';

export function LauncherDownloadLink() {
  const url = new URL('/launcher', location.origin).href;
  return (
    <div className="stack small">
      <p className="muted">プレイヤーに渡す配布ページの URL です。ログインなしでダウンロードと入れ方を確認できます。</p>
      <a href={url} target="_blank" rel="noreferrer">
        配布ページを開く
      </a>
      <CopyBox value={url} />
    </div>
  );
}
